import { render, staticRenderFns } from "./DetailKecelakaanPage.vue?vue&type=template&id=80153692"
import script from "./DetailKecelakaanPage.vue?vue&type=script&lang=js"
export * from "./DetailKecelakaanPage.vue?vue&type=script&lang=js"
import style0 from "./DetailKecelakaanPage.vue?vue&type=style&index=0&id=80153692&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports